import * as authApi from "@/src/api/auth";
import {OP, trackPending} from "@/src/queries/pending";
import * as usersApi from "@/src/api/users";
import { LoginType } from "@/src/api/auth";
import { getAuth, signOut } from 'firebase/auth';
import { IS_TRAINING_INSTANCE } from '@/src/utils/utils';

export default {
    namespaced: true,
    state: {
        user: null,
        loginType: null, // BASIC or SSO
        authIsReady: false,
        groups: [],
        users: [],
        roles: [],
        globalPermissions: [],
        preferences: {}
    },
    mutations: {
        setUser(state, user) {
            if (!user) {
                state.user = null
                return
            }
            state.user = {email: user.email, uid: user.uid}
        },
        setLoginType(state, payload) {
            state.loginType = payload
            console.log('login type state change:', state.loginType)
        },
        setAuthIsReady(state, payload) {
            state.authIsReady = payload
        },
        setGroups(state, groups) {
            state.groups = groups
        },
        setUsers(state, users) {
            state.users = users
        },
        setRoles(state, roles) {
            state.roles = roles
        },
        setPreferences(state, preferences) {
            state.preferences = preferences
        }
    },
    actions: {
        async login({commit, dispatch}, {username, password}) {
            console.log('login action')
            const res = await authApi.login(username, password).catch(err => {
                throw new Error('Invalid username or password')
            })
            if (res) {
                commit('setUser', res)
                console.log('User ' + res)
            }
        },
        async logout() {
            const auth = getAuth();
            try {
                await signOut(auth)
                //by reloading store is reset
                location.reload()
            } catch (e) {
                console.log('Signout error: ' + e)
            }
        },
        async ssoBackendValidation({commit, dispatch}, {uid, idToken}) {
            console.log('samlPortalLogin action: ' + uid + ', ' + idToken)
            const res = await authApi.samlLogin(uid, idToken).catch(err => {
                console.log(err)
                throw new Error('saml portal login error')
            })
            if (res) {
                commit('setUser', res)
                commit('setLoginType', LoginType.FIREBASE_SSO)
                console.log('sam result: ' + res)
            }
        },
        async user({dispatch, commit}) {
            const res = await authApi.getCurrentUser()
            commit('setUser', res)
            commit('setAuthIsReady', true)
        },
        loadUsers: async({commit}) => {
            const users = await trackPending(OP.USERS, () => usersApi.listUsers())
            commit('setUsers', users)
        },
        loadGroups: async({commit}) => {
            const groups = await trackPending(OP.GET_GROUPS, () => usersApi.listGroups())
            commit('setGroups', groups)
        },
        loadRoles: async({commit}) => {
            const roles = await usersApi.listRoles()
            commit('setRoles', roles)
        },
        loadUsersAndGroups: async({commit, dispatch}) => {
            await dispatch('loadUsers')
            await dispatch('loadGroups')
            await dispatch('loadRoles')
        },
        addGroup: async({commit, dispatch}, {name}) => {
            await usersApi.createGroup(name)
            dispatch('loadGroups')
        },
        deleteGroup: async({commit, dispatch}, id) => {
            await usersApi.deleteGroup(id)
            dispatch('loadUsersAndGroups') // reload both as the group deletion may have affected users
        },
        editGroup: async({commit, dispatch}, {id, data}) => {
            await usersApi.updateGroup(id, data)
            dispatch('loadUsersAndGroups')
        },
        editUser: async({commit, dispatch}, {id, data}) => {
            await trackPending(OP.EDIT_USER, () => usersApi.updateUser(id, data))
            dispatch('loadUsersAndGroups')
        },
        deleteUser: async({commit, dispatch}, id) => {
            await trackPending(OP.DELETE_USER, () => usersApi.deleteUser(id))
            dispatch('loadUsersAndGroups')
        },
        inviteUser: async({commit, dispatch}, data) => {
            await trackPending(OP.INVITE_USER, () => usersApi.inviteUser(data))
            dispatch('loadUsers')
        },
        loadGlobalPermissions: async({state, commit}) => {
            state.globalPermissions = await trackPending(OP.GET_GLOBAL_PERMISSIONS, () => authApi.getGlobalPermissions())
        },
        updateRoleUsers: async({commit, dispatch}, {roleId, users}) => {
            await usersApi.updateRoleUsers(roleId, users)
            dispatch('loadUsersAndGroups')
        },
        loadUserPreferences: async({commit}) => {
            const preferences = await authApi.getUserPreferences()
            commit('setPreferences', preferences)
        },
        updateUserPreference: async({commit}, {preference, value}) => {
            const pref = await authApi.updateUserPreference(preference, value)
            commit('setPreferences', pref)
        }
    },
    getters: {
        user: state => state.user,
        groups: state => state.groups,
        users: state => state.users,
        roles: state => state.roles,
        globalPermissions: state => state.globalPermissions,
        userCan: (state, getters, rootState, rootGetters) => (permissionName, object) => {
            const globalPermissions = state.globalPermissions
            if (globalPermissions.hasOwnProperty('manage_graphs')) {
                return true
            }
            if (!object || !object.permissions) {
                return false
            }
            // const graphPermissions = rootGetters['repoStore/getGraphUserPermissions']
            // const workspacePermissions = rootGetters['repoStore/getWorkspaceUserPermissions']
            return object.permissions.includes(permissionName)
        },
        preferences: state => state.preferences,
        isGraphAdmin: state => {
            return state.globalPermissions.hasOwnProperty('manage_graphs')
        },
        isTrainee: (state, getters) => {
            return IS_TRAINING_INSTANCE && !getters.isGraphAdmin
        },
        isTrainer: (state, getters) => {
            return IS_TRAINING_INSTANCE && getters.isGraphAdmin
        }
    }
}